import { xfetch } from '../../lib/xfetch';
import { ResponseUnknownError } from '../../lib/xfetch/errors-types';
import { REQUEST_TIMEOUT, SESSION_API, switchToSiApi } from '../config';
import { ApiError, ResponseSuccessFieldError, type BaseResponseData } from '../types';

export class SessionCreationError extends ApiError {
  constructor(...args: ConstructorParameters<typeof ApiError>) {
    super(...args);
  }
}

export const createSession = async (): Promise<BaseResponseData> => {
  const tryCreate = async (endpoint: string): Promise<BaseResponseData> => {
    try {
      const data = await xfetch<BaseResponseData>(endpoint, {
        timeout: REQUEST_TIMEOUT,
        data: { token: 'site' }
      });
      if (!data.success) throw new ResponseSuccessFieldError();
      return data;
    } catch (error) {
      //  Любая ошибка из tryCreate - SessionCreationError
      throw new SessionCreationError(undefined, { cause: error });
    }
  };

  try {
    return await tryCreate(`${SESSION_API}/create`);
  } catch (error) {
    // Type guard для проверки что error является SessionCreationError
    if (!(error instanceof SessionCreationError)) {
      throw new SessionCreationError(undefined, { cause: error });
    }
    // Безопасное извлечение cause с проверкой типа
    const originalError = error.cause;

    if (originalError instanceof ResponseUnknownError && originalError.responseStatus === 430) {
      switchToSiApi();
      return await tryCreate(`${SESSION_API}/create_si`);
    }

    // Пробрасываем существующую SessionCreationError
    throw error;
  }
};
